import { animate, style, transition, trigger } from '@angular/animations';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  Output,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { downloadFile } from '@commons/bo-ui/form/file-picker/utils/dowload-file';

@Component({
  selector: 'app-file-actions',
  templateUrl: './file-actions.component.html',
  styleUrls: ['./file-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('expand', [
      transition(':enter', [
        style({ opacity: '.4', overflow: 'hidden', width: '0' }),
        animate('400ms linear', style({ width: '*', opacity: '1' })),
      ]),
      transition(':leave', [
        style({ overflow: 'hidden' }),
        animate('400ms linear', style({ width: '0', opacity: '.4' })),
      ]),
    ]),
  ],
  imports: [MatIconButton],
})
export class FileActionsComponent {
  @Input() fileSrc!: string;
  @Input() isDownloadable!: boolean;
  @Output() fileCancelled = new EventEmitter<void>();

  showDeleteConfirmation = false;

  readonly #elementRef = inject(ElementRef);

  async downloadUploadedFile(): Promise<void> {
    const file = await fetch(this.fileSrc);
    const fileBlob = await file.blob();
    downloadFile(fileBlob);
  }

  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent): void {
    if (!this.#elementRef.nativeElement.querySelector('.actions').contains(event.target)) {
      this.showDeleteConfirmation = false;
    }
  }
}
